import "./ui/styles/CasinoCategories.scss";
import React from "react";
import {Device} from "../utils/Device";
import "./ui/styles/CasinoTabView.scss";
import "./LoadingCasinoLobby.scss";
import {AppState, useAppSelector} from "../RootReducer";
import { useSelector } from "react-redux";

export const LoadingCasinoGames = (props: {isMobile?: boolean}) => (
    <div className={"casino-tab-view"}>
        <div className={"main-container"}>
            <div className={"container container-fluid"}>
                <div className={"casino-games-container"}>
                    <div className="row games-list title">
                        <h5 className={"loading"}>title</h5>
                    </div>
                    <div className={"row games-list"}>
                        {[1,2,3,4,5,6,7,8,9,10].map(i => (
                            <div key={i} className={props.isMobile ?  "casino-game mobile" : "casino-game"}>
                                <div className={"game-box"} >
                                    <div className="content loading">
                                        <div className={"content-overlay"}/>
                                        <div  className={"thumbnail"} >
                                            <div className={"play-now"}>
                                                <div className={"game-title"}>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </div>
    </div>
)
export const LoadingCasinoLobby = (props : {}) => {
    const isMobile = useSelector((app: AppState)=> app.settings.mobile)



    return (
        <>
            <div className={"casino-container loading-skeleton-container"} style={{marginTop : "0px"}}>
                <div className="container-fluid search-and-filter-wrapper">
                    <div className="container search-and-filter-container loading">
                        <div className="row">
                            <div className="col-md-9 filter-column">
                                <div className="container">
                                    <div className="casino-filters-container">

                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 search-column">
                                <div className="search-container ">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"container"}>
                    <div className={"container categories-container"}>
                        <ul className={"navbar-nav flex-row casino-lobby-categories " + (isMobile ? `${"row"} ${"mobile"}` : "row")}>
                            {[1,2,3,4].map(i => (
                                <li key={i} className={"nav-item"}>
                                    <a className={ "nav-link"}>
                                <span className={"title"}>
                                    <span className={"loadingCategory"}/>
                                </span>
                                    </a>
                                </li>
                            ))}

                        </ul>
                    </div>
                </div>
                <LoadingCasinoGames isMobile={isMobile}/>
            </div>
        </>

    )
}